<iframe
  width="100%"
  height="100%"
  class="iframe-border"
  title="accountsFrame"
  [src]="urlSafe">
</iframe>
